<div class="d-flex h-100 justify-content-center spinner-container" *ngIf="isLoading">
    <div class="text-center align-self-center">
        <div class="spinner-border text-gray-700" role="status"></div>
        @if(spinnerMsg){
            <p class="small text-gray-700">{{ spinnerMsg }}...</p>
        }@else{

            <p class="small text-gray-700">Loading...</p>
        }
    </div>
</div>

